import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TabPanelBatteryFirmware: FunctionComponent<Props> = ({
    battery,
    className = '',
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const hasHistory = battery.firmwareHistory.length > 0;

    return (
        <VerticalContainer
            className={`${styles.tabPanelBatteryFirmware} ${className}`}
            testId={testId}>
            <HorizontalContainer className={styles.row}>
                <Wrapper className={styles.label}>{t.FIRMWARE_VERSION}</Wrapper>

                <Wrapper className={styles.value}>{battery.firmwareVersion}</Wrapper>
            </HorizontalContainer>

            <Wrapper className={styles.label}>{t.FIRMWARE_HISTORY}</Wrapper>

            <VerticalContainer className={styles.firmwareHistory}>
                {hasHistory ? (
                    battery.firmwareHistory.map(entry => (
                        <Wrapper className={styles.firmwareEntry} key={`${entry.at}-${entry.to}`}>
                            {`${entry.from} → ${entry.to} · ${entry.at.slice(0, 10)} · ${entry.by}`}
                        </Wrapper>
                    ))
                ) : (
                    <Wrapper className={styles.firmwareEntry}>{t.NO_FIRMWARE_HISTORY}</Wrapper>
                )}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default TabPanelBatteryFirmware;
